import getSystemInfo, { IGetSystemInfoResult } from '@/packages/jsapi/basic/getSystemInfo';
import fabric from '@/pages/customize/utils/newFabric';
import { Dialog, Popover, Popup, Toast } from 'antd-mobile';
import { useContext, useEffect, useRef, useState } from 'react';
import { myContext } from '../../context-manager';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import './index.scss';
import Magnifier from './components/magnifier';
import Util from './util';
import Preview from './components/preview/index';
import { useUpdateEffect } from 'ahooks';
import { getNewImage, getPreviewImage, getItemPreviewImage } from '@/services/rpc/review';
import { getUploadToken } from '@/services/rpc/customize';
import axios from 'axios';
import OSS from 'ali-oss';
import { v4 as uuid } from 'uuid';
import { base64ToFile } from '@/pages/customize/utils';
import { ID_LIST } from '../constant';

let canvasIns = null;
let stateArr = []; //记录画布操作步骤;
let recordTimer = null;
let isfirst = true;
let timer = null;
let cirTimer = null;
const defaultOpcity = 0.6;
const canvasConfig = {
  yResolution: 100,
  customWidth: window.innerWidth > 720 ? 440 : window.innerWidth,
  customHeight: window.innerWidth > 720 ? 400 : window.innerWidth * 0.96,
};
interface ICanvasData {
  width: number;
  height: number;
  left: number;
  top: number;
  scaleY: number;
  scaleX: number;
}
const defaultTop = 60;
let canvasUtil = null;
let backgroundImg = '';
const Edit = (props: any) => {
  const { itemId, skuId = 'HHOLOVE_PET_KEYCHAIN' } = props;
  const { cover, setCover, image } = useContext(myContext);
  const [visible, setVisible] = useState<boolean>(false);
  const [cir, setCir] = useState<number>(2);
  const [showCir, setShowCir] = useState<boolean>(false);
  const [type, setType] = useState<number>(0); // 0.默认 1 擦出 2. 复原
  const [canvasData, setCanvasData] = useState<ICanvasData>(null);
  const [isNewUser, setIsNewUser] = useState<boolean>(false);
  const [isZoom, setIsZoom] = useState<boolean>(false);
  const zoomRef = useRef<any>(null);
  const previewRef = useRef<any>(null);
  const [previewVisible, setPreviewVisible] = useState<boolean>(false);
  let w = window.innerWidth > 720 ? 440: window.innerWidth
  let point = null;

  useEffect(()=>{
    if(isDesktop()){
      const result = Dialog.show({
        content: "We have found that you are using a PC to edit your images and some features may be affected. We recommend using it on mobile for a better experience",
        actions: [
          [
            {
              key: 'close',
              text: 'Exit',
              onClick: () => {
                result?.close();
              }
            },
            {
              key: 'confirm',
              text: 'Confirm',
              style:{ color: 'rgb(238,126,49)'},
              onClick:  () =>{
                result?.close();
              }
            }
          ]
        ]
      });
    }
  },[])

  const imageClear = () => {
    if (type === 2) {
      if (canvasIns.backgroundImage) {
        canvasIns.backgroundImage = null;
        let rect = canvasIns.getItemsByName('transparent_bg');
        rect.set({ opacity: 0 });
        canvasIns.renderAll();
      }
    }
    setVisible(true);
    setType(1);
    console.log(canvasIns.isDrawingMode);
    
    Toast.show({
      content: 'The image in the filled area will disappear.'
    });
    let bg = canvasIns.getItemsByName('transparent_bg');
    let mainImg = canvasIns.getItemsByName('main-img');
    bg.set({ erasable: false });
    mainImg.set({ erasable: true });
    canvasIns.isDrawingMode = true;
  };

  const imageReset = () => {
    setVisible(true);
    setType(2);
    // 涂抹相应区域可以修复图像
    Toast.show({
      content: 'You can modify the image in the filled area.'
    });
    if (!canvasIns.backgroundImage) {
      canvasUtil.addOriginBg();
      let bg = canvasIns.getItemsByName('transparent_bg');
      let mainImg = canvasIns.getItemsByName('main-img');
      mainImg.set({ erasable: false });
      bg.set({ erasable: true, opacity: defaultOpcity, fill: '#fff' });
      canvasIns.isDrawingMode = true;
      canvasIns.renderAll();
    }
  };

  const handleCustomizeImageUpload = async () => {
    const result = await Dialog.show({
      content: "If Change it, You can't save the current design",
      actions: [
        [
          {
            key: 'close',
            text: 'Exit',
            onClick: () => {
              result?.close();
            }
          },
          {
            key: 'confirm',
            text: 'Confirm',
            style:{ color: 'rgb(238,126,49)'},
            onClick:  () =>{
              location.href = `${location.origin}/review.html#/upload`
            }
          }
        ]
      ]
    });
  };

  const handleAddRemoteImg = (url: string) => {
    const i = new Image();
    i.setAttribute('crossOrigin', 'anonymous');
    i.src = url;
    i.onload = function () {
      Toast.clear();
      const fabricImage = new fabric.Image(i);
      let scaleY = Math.round((canvasConfig.customHeight / i.height) * 100) / 100;
      const left = (w - i.width * scaleY * 0.8) / 2;
      const top = (w * 2 - i.height * scaleY) / 2 - defaultTop;
      let rect = canvasUtil.addRectBg(left, top, i.width * scaleY, i.height * scaleY);
      canvasIns.add(rect);
      fabricImage.set({
        name: 'main-img',
        left,
        top: top,
        scaleX: scaleY,
        scaleY,
        width: i.width,
        height: i.height,
        cornerStyle: 'circle',
        transparentCorners: true,
        cornerSize: 6,
        // rx: 40,
        visible: true,
        selectable: false
      });
      let obj = {
        width: i.width * scaleY,
        height: i.height * scaleY,
        scaleX: scaleY,
        scaleY,
        top,
        left
      };
      canvasUtil.setCanvasData(obj);
      setCanvasData(obj);

      canvasIns?.add(fabricImage);
      canvasIns.renderAll();
      stateArr.push(canvasIns.toJSON(['name']));
      canvasUtil.addHis();
      Toast.show({
        content: (
          <div className='other-tips'>
            <img alt="edit" src='https://static.hhocool.com/images/77dc7137-a68f-411e-96c3-32f7eefdcf4d_48x49.png' />
            Clipping is complete.
          </div>
        )
      });
      setIsZoom(true);
    };
  };
  function isDesktop() {
    const userAgentInfo = navigator.userAgent;
    const agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    for (let i = 0; i < agents.length; i++) {
      if (userAgentInfo.indexOf(agents[i]) > 0) {
        return false; // 当前设备是移动设备
      }
    }
    return true; // 当前设备是桌面电脑
  }
  const init = () => {
    const bgCanvas = new fabric.Canvas('edit-content-bg', {
      controlsAboveOverlay: true,
      enableRetinaScaling: true,
      selection: false
    });
    bgCanvas.setWidth(w);
    bgCanvas.setHeight(w * 2);

    canvasIns = new fabric.Canvas('edit-content', {
      controlsAboveOverlay: true,
      enableRetinaScaling: true,
      selection: false
    });
    canvasIns.setWidth(w);
    canvasIns.setHeight(w * 2);
    canvasIns.freeDrawingBrush = new fabric.EraserBrush(canvasIns);
    canvasIns.freeDrawingBrush.width = 8;

    handleAddRemoteImg(cover);
    canvasUtil = new Util(canvasIns, canvasConfig, backgroundImg, itemId, {
      stateArr
    });
    canvasUtil.shapeBg(bgCanvas);

    let zoomStartScale;
    canvasIns.on('touch:gesture', (e) => {
      if (e.e.touches && e.e.touches.length == 2) {
        console.log(e.self.state);
        if (e.self.state === 'start') {
          zoomStartScale = canvasIns.getZoom();
        }
        let delta = zoomStartScale * e.self.scale;
        if (delta > 2) delta = 2;
        if (delta < 0.5) delta = 0.5;
        canvasIns.zoomToPoint({ x: w / 2, y: (w * 1.4) / 2 }, delta);
      }
    });
    canvasIns.on('mouse:down', (options) => {
      if (canvasIns.isDrawingMode) {
        let obj: HTMLElement = document.querySelector('.brush-cir');
        if (obj.style.display === 'block') {
          clearTimeout(cirTimer);
        }
        if (obj.style.display === 'none') {
          obj.style.display = 'block';
        }
        obj.style.top = `${Math.ceil(options.pointer.y) - canvasIns.freeDrawingBrush.width / 2}px`;
        obj.style.left = `${Math.ceil(options.pointer.x) - canvasIns.freeDrawingBrush.width / 2}px`;
        let bg = canvasIns.getItemsByName('transparent_bg');
        if (bg.opacity !== defaultOpcity) {
          zoomRef.current.down(options);
        }
      } else {
        point = canvasIns.getPointer();
      }
      if (isNewUser) {
        setIsNewUser(false);
      }
    });
    canvasIns.on('mouse:move', (opt) => {
      if (canvasIns.isDrawingMode) {
        let obj: HTMLElement = document.querySelector('.brush-cir');
        if (obj.style.display === 'block') {
          obj.style.top = `${Math.ceil(opt.pointer.y) - canvasIns.freeDrawingBrush.width / 2}px`;
          obj.style.left = `${Math.ceil(opt.pointer.x) - canvasIns.freeDrawingBrush.width / 2}px`;
        }
        let bg = canvasIns.getItemsByName('transparent_bg');
        if (bg.opacity !== defaultOpcity) {
          zoomRef.current.move(opt);
        }
      } else {
        let obj = opt.target;
        if (!obj) return;
        let deltaX = opt.absolutePointer.x - point.x;
        let deltaY = opt.absolutePointer.y - point.y;
        // // 左边缘检测
        // if (obj.left + offsetX < 1 && deltaX < 0) {
        //   return;
        // }
        // // 有边缘检测
        // if (obj.left - offsetX < 0 && deltaX > 0) {
        //   return;
        // }
        // // 上边缘检测
        // if (obj.top + offsetY < 1 && deltaY < 0) {
        //   return;
        // }
        // // 下边缘检测
        // if (obj.top - offsetY < 0 && deltaY > 0) {
        //   return;
        // }
        var delta = new fabric.Point(deltaX, deltaY);
        canvasIns.relativePan(delta);
      }
    });
    canvasIns.on('mouse:up', (options) => {
      if (canvasIns.isDrawingMode) {
        cirTimer = setTimeout(() => {
          let obj: HTMLElement = document.querySelector('.brush-cir');
          if (obj.style.display === 'block') {
            obj.style.display = 'none';
          }
        }, 1000);
        let bg = canvasIns.getItemsByName('transparent_bg');
        if (bg.opacity !== defaultOpcity) {
          zoomRef.current.mouseUp(options);
        }
      }
    });
    canvasIns.on('erasing:end', () => {
      if (!canvasUtil.isRedoing) {
        // 当前不是进行撤销或重做操作
        // 在绘画时会频繁触发该回调，所以间隔0.5s记录当前状态
        if (recordTimer) {
          clearTimeout(recordTimer);
          recordTimer = null;
        }
        recordTimer = setTimeout(() => {
          stateArr.push(canvasIns.toJSON(['name']));
          if (isfirst) {
            isfirst = false;
            return;
          }
          stateArr.push(canvasIns.toJSON(['name']));
          canvasUtil.addHis();
        }, 500);
      }
    });
    canvasIns.on('after:render', () => {
      canvasUtil.updateRedoing(false);
    });
    let newUser = localStorage.getItem('hho_cus_newUser');
    if (!newUser) {
      setIsNewUser(true);
      localStorage.setItem('hho_cus_newUser', '1');
    }
  };

  useUpdateEffect(() => {
    if (backgroundImg !== image) {
      init();
      zoomRef.current.init();
    }
  }, [cover]);

  useEffect(() => {
    backgroundImg = image;
    // let w = window.innerWidth;
    getSystemInfo().then((res: IGetSystemInfoResult) => {
      (document.querySelector('#root') as any)?.style.setProperty(
        '--top',
        `${res.statusBarHeight}px`
      );
    });
    init();
  }, []);

  return (
    <div
      className='review-edit'
      onClick={() => {
        if (isNewUser) {
          setIsNewUser(false);
        }
      }}
    >
      <div className='hho_cus_edit'>
        <div className='edit-top'>
          <div className='left-func'>
            <span
              className='iconfont icon-icon_left_line'
              onClick={async () => {
                const result = await Dialog.show({
                  content:
                    'One step closer to completion. Do you want to abandon your current design?',
                  actions: [
                    [
                      {
                        style:{color:'rgb(238,126,49)'},
                        key: 'submit',
                        text: 'Submit',
                        onClick: () => {
                          result?.close();
                        }
                      },
                      {
                        key: 'close',
                        text: 'Close',
                        onClick: async () => {
                          location.href = 'https://hholove.com/products/customized-keychain'
                        }
                      }
                    ]
                  ]
                });
              }}
            />
          </div>
          <Popover
            content={
              <>
                <div className='top-tips'>
                  Click on the Design Completion button to go to the order screen.
                  <img
                    src='https://static.hhocool.com/images/78208b0d-ce59-40bb-b373-091eeea213d7_78x99.png'
                    alt=''
                  />
                </div>
              </>
            }
            visible={isNewUser}
            mode='dark'
            trigger='click'
            placement='bottom'
            defaultVisible
          >
            <span
              className='right-btn'
              onClick={async () => {
                if (canvasIns.backgroundImage) {
                  return;
                }
                // 预览
                Toast.show({
                  icon: 'loading',
                  content: 'Please Waiting',
                  duration: 0
                });
                try {
                  let scale = (innerWidth - 20) / canvasData.width;
                  canvasIns.viewportTransform = [1, 0, 0, 1, 0, 0];
                  canvasIns.renderAll();
                  const dataUrl = canvasIns.toDataURL({
                    format: 'png',
                    quality: 1,
                    multiplier: 4,
                    top: canvasData.top,
                    left: canvasData.left,
                    width: canvasData.width,
                    height: canvasData.height
                  });
                  const result: any = await getUploadToken();
                  const client = new OSS({
                    region: result.region,
                    accessKeyId: result.accessKeyId,
                    accessKeySecret: result.accessKeySecret,
                    stsToken: result.securityToken,
                    bucket: result.bucketName
                  });
                  const file1 = await base64ToFile(dataUrl);
                  const previewImage = await client.put(`${uuid()}.png`, file1);
                  const res = await getItemPreviewImage(previewImage.url, itemId, skuId);
                  // const res = await getPreviewImage(previewImage.url)
                  Toast.clear();
                  previewRef.current.toImgPreview(res.previewImg);
                } catch {
                  Toast.show({
                    content: 'Please Retry'
                  });
                }
              }}
            >
              Complete
            </span>
          </Popover>
        </div>
        <div className='edit-con'>
          <Magnifier ref={zoomRef} canvasIns={canvasIns} isZoom={isZoom} cir={cir}></Magnifier>
          <canvas id='edit-content-bg' />
          <div className='edit-content'>
            <canvas id='edit-content' />
            <div
              className='brush-cir'
              style={{
                display: 'none',
                width: '16px',
                height: '16px',
                top: '100px',
                left: '100px'
              }}
            ></div>
          </div>
        </div>
        <Popover
          content={
            <>
              <div className='top-tips'>
                You can edit images here.
                <img
                  src='https://static.hhocool.com/images/8abe0451-7317-41cf-a1c2-30d841fe515e_76x96.png'
                  alt=''
                />
              </div>
            </>
          }
          mode='dark'
          visible={isNewUser}
          trigger='click'
          placement='bottom'
          defaultVisible
        >
          <div className='edit-bottom'>
            <div className='main'>
              <div className='item' onClick={() => imageClear()}>
                <img
                  src='https://static.hhocool.com/images/ded0b44f-4b14-4b0b-97ff-9d59b4ee8450_72x72.png'
                  alt=''
                />
                <span>Rubber eraser</span>
              </div>
              <div className='item' onClick={() => imageReset()}>
                <img
                  src='https://static.hhocool.com/images/7da34269-c6e1-4d84-a4ce-fa71577cede9_72x72.png'
                  alt=''
                />
                <span>Brushes</span>
              </div>
              <div
                className='item'
                onClick={() => {
                  handleCustomizeImageUpload();
                }}
              >
                <img
                  src='https://static.hhocool.com/images/e8fd0906-6fb0-4a90-9977-b39116a0ecaf_72x72.png'
                  alt=''
                />
                <span>Photo change</span>
              </div>
            </div>
          </div>
        </Popover>
        <Popup
          visible={visible}
          mask={false}
          onMaskClick={() => {
            canvasIns.isDrawingMode = false;
            setVisible(false);
          }}
          bodyStyle={{ height: '24vh' }}
          style={{
            '--z-index': '1000'
          }}
        >
          <div className='bottom-eraser-com'>
            <h4 className='title'>{type === 2 ? 'Restoration Brushes' : 'Eraser'}</h4>
            <div className='con'>
              <div className='con-slider'>
                <div className='small'></div>
                <Slider
                  min={1}
                  max={10}
                  step={1}
                  defaultValue={4}
                  onChange={(val: number) => {
                    clearTimeout(timer);
                    canvasIns.freeDrawingBrush.width = val * 4;
                    let obj: HTMLElement = document.querySelector('.brush-cir');
                    obj.style.width = `${val * 4}px`;
                    obj.style.height = `${val * 4}px`;
                    setCir(val);
                    setShowCir(true);
                    timer = setTimeout(() => {
                      setShowCir(false);
                    }, 3000);
                  }}
                />
                <div className='big'></div>
              </div>
              <p>{type === 2 ? 'Brush Size' : 'Eraser size'} </p>
            </div>
            <div className='eraser-bottom'>
              <span
                className='iconfont icon-icon_close'
                onClick={() => {
                  setType(0);
                  canvasIns.isDrawingMode = false;
                  setVisible(false);
                  if (type === 2) {
                    if (canvasIns.backgroundImage) {
                      let list = canvasIns.getObjects();
                      canvasIns.backgroundImage = '';
                      let rect = list[0];
                      rect.set({ opacity: 0 });
                      canvasIns.renderAll();
                    }
                  }
                }}
              ></span>
              <span
                className='iconfont icon-icon_mark_fill'
                onClick={() => {
                  setType(0);
                  canvasIns.isDrawingMode = false;
                  let path = canvasIns.getItemsByName('transparent_bg');
                  setVisible(false);
                  if (type === 2) {
                    if (path?.eraser) {
                      path.eraser.set({
                        scaleX: 1 / canvasData.scaleX,
                        scaleY: 1 / canvasData.scaleX
                      });
                      let clipPath = path.eraser;
                      clipPath.inverted = true;
                      canvasIns.backgroundImage.set({ clipPath: clipPath });
                      delete path.eraser;
                      path.dirty = true;
                    } else {
                      canvasIns.backgroundImage = null;
                    }
                    path.set({ opacity: 0 });
                    canvasIns.renderAll();
                  }
                  canvasIns.viewportTransform = [1, 0, 0, 1, 0, 0];
                  const dataUrl = canvasIns.toDataURL({
                    format: 'png',
                    quality: 1,
                    multiplier: 1 / canvasData.scaleX,
                    top: canvasData.top,
                    left: canvasData.left,
                    width: canvasData.width,
                    height: canvasData.height
                  });
                  let imgObj = canvasIns.getItemsByName('main-img');
                  delete imgObj.eraser;
                  imgObj.dirty = true;
                  imgObj.setSrc(dataUrl, () => {
                    if (type === 2) {
                      canvasIns.backgroundImage = null;
                    }
                    canvasIns.renderAll();
                    zoomRef.current.updateImage();
                  });
                }}
              ></span>
            </div>
            {showCir && (
              <div className='show-cir'>
                <div
                  className='current-cir'
                  style={{
                    width: `${3 * cir}px`,
                    height: `${3 * cir}px`,
                    marginLeft: `-${(3 * cir) / 2 + 1}px`,
                    marginTop: `-${(3 * cir) / 2 + 1}px`
                  }}
                ></div>
              </div>
            )}
          </div>
        </Popup>
        <Preview
          ref={previewRef}
          previewVisible={previewVisible}
          setPreviewVisible={setPreviewVisible}
          canvasData={canvasData}
          onOk={async (coverImage) => {
            canvasIns.viewportTransform = [1, 0, 0, 1, 0, 0]; // 解决放大缩小的问题
            const dataUrl = canvasIns.toDataURL({
              format: 'png',
              quality: 1,
              multiplier: 3,
              top: canvasData.top,
              left: canvasData.left,
              width: canvasData.width,
              height: canvasData.height
            });
            window.gtag && window.window?.gtag('event', 'customize_finish_click', {
              detail: 'customize_finish'
            });
            const { imageUrl, templateId } = await canvasUtil.getImage(dataUrl);
            setCover(dataUrl);
            Toast.show({content:'Please wait',icon:'loading'})
            
            const config = {
              headers: {
                // 'X-Shopify-Access-Token': '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',
                'Content-Type': 'application/graphql',
                'Access-Control-Allow-Origin':'*'
              }
            };
            axios
            .post(
              'https://api.hhopla.com/restroom/enter/api/2023-04/graphql.json',
              `mutation {
            fileCreate (
                files:{
                    alt:"customize-image",
                    contentType:IMAGE,
                    originalSource:"${imageUrl}"
                }
            ){
                files {
                    fileStatus,
                    preview {
                        image {
                            id
                            url
                        }
                        status
                    }
                  }
              userErrors {
                message
              }
            }
        }`,
              config
            )
            .then((res) => {
              const data = res.data.data
                .replace(/\\"/g, '"')
                .replace(/]"/g, ']')
                .replace(/"\[/g, '[');
              let validateData = {} as any;
  
              try {
                validateData = JSON.parse(data);
                if(validateData.data && validateData.data.fileCreate && validateData.data.fileCreate.files && validateData.data.fileCreate.files.length && validateData.data.fileCreate.files[0].fileStatus == 'UPLOADED'){
                  const customizeParts = imageUrl.split('/')
                  const filename = customizeParts[customizeParts.length - 1];
                  const productsName = ID_LIST.find(item=>item.skuId === skuId).productsName;
                  location.href = `https://hholove.com/products/${productsName}?customizedImage=${imageUrl}&designImage=https://cdn.shopify.com/s/files/1/0734/4475/3685/files/${filename}&mainImage=${coverImage}&templateId=${templateId}&skuId=${skuId}`
                }else {
                      Toast.show('Network Error');
                      
                }
                
              } catch (error) {

                
                Toast.show('Network Error,Please Retry');
              }
            }).catch(()=>{
              Toast.show('Network Error,Please Retry');
            });
          }}
        />
        <span
          className='iconfont icon-icon_nextstep_line func-icon'
          onClick={() => {
            canvasUtil.tapHistoryBtn(-1);
          }}
          style={{
            bottom: 181
          }}
        ></span>
        <span
          className='iconfont icon-icon_previous_line func-icon'
          onClick={() => {
            canvasUtil.tapHistoryBtn(1);
          }}
          style={{
            bottom: 121
          }}
        ></span>
      </div>
    </div>
  );
};

export default Edit;
